import { determineBaseUrlAndPerformApiCall } from "../../interceptor/interceptor"
import { INVOICE_FOR_CUSTOMER_AND_LISTING_API } from "../../constants/constants"
import { fetchInvoiceListForCustomerFailure,fetchInvoiceListForCustomerSuccess } from "./reducer"

export const fetchAllInvoicesForCustomer = (setLoading,customerId) => async (dispatch) => {
    try {
        setLoading(true)
        const response = await determineBaseUrlAndPerformApiCall(`${INVOICE_FOR_CUSTOMER_AND_LISTING_API}/${customerId}`,'GET')
        setLoading(false)
        dispatch(fetchInvoiceListForCustomerSuccess(response.reverse()))
    }
    catch (error) {dispatch(fetchInvoiceListForCustomerFailure(error.message)) }
}